<template>
  <div>
    <div class="form-group">
      <label>Target Url</label>
      <input type="text" class="form-control" v-model="data.targetUrl">
    </div>
    <div class="form-group">
      <label>Public Key</label>
      <input type="text" class="form-control" v-model="data.publicKey">
    </div>
    <div class="form-group">
      <label>Secret Key</label>
      <input type="text" class="form-control" v-model="data.secretKey">
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: [
    'data'
  ],
  data() {
    return {
    };
  }
}
</script>